import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { KeycloakEvent, KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { tap } from 'rxjs';

import { FeatureFlagsService } from '../../service/feature-flags.service';

@Injectable()
export class DataAccessTogglesEffects {
  setContext$ = createEffect(
    () =>
      this.keycloakService.keycloakEvents$.pipe(
        tap((keycloakEvent: KeycloakEvent) => {
          const processLogin = (status: boolean) => {
            if (status) {
              this.featureFlagsService.updateContext({
                userId: instance?.tokenParsed?.sub,
                sessionId: instance?.sessionId,
                properties: {
                  roles: (instance?.tokenParsed?.realm_access?.roles ?? []).join(','),
                },
              });
            } else {
              this.featureFlagsService.updateContext({});
            }
          };

          const instance = this.keycloakService.getKeycloakInstance();

          if (KeycloakEventType.OnReady === keycloakEvent.type) {
            processLogin(this.keycloakService.isLoggedIn());
          } else if (
            KeycloakEventType.OnAuthRefreshError === keycloakEvent.type ||
            KeycloakEventType.OnAuthLogout === keycloakEvent.type
          ) {
            processLogin(false);
          } else if (
            KeycloakEventType.OnAuthSuccess === keycloakEvent.type ||
            KeycloakEventType.OnAuthRefreshSuccess === keycloakEvent.type
          ) {
            processLogin(true);
          }
        })
      ),
    { dispatch: false }
  );

  constructor(private featureFlagsService: FeatureFlagsService, private keycloakService: KeycloakService) {}
}
